import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import CategoryForm from '@/components/v2/ecommerce/CategoryForm.vue';
import CategoryUpdateMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryUpdateMixin';
import InitialCategory from '@/plugins/graphql/queries/v2/diy/category.gql';
import { EcommerceCategoryModel } from '@/helpers/entities/models/EcommerceCategoryModel';
let CategoryInitial = class CategoryInitial extends mixins(CategoryUpdateMixin) {
    get header() {
        return 'Categories';
    }
    get caption() {
        return 'Add Product Category';
    }
};
__decorate([
    Prop({ type: String, required: true })
], CategoryInitial.prototype, "appUuid", void 0);
CategoryInitial = __decorate([
    Component({
        components: {
            CategoryForm,
        },
        apollo: {
            category: {
                query: InitialCategory,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    return new EcommerceCategoryModel(data.categoryInitial);
                },
            },
        },
    })
], CategoryInitial);
export default CategoryInitial;
